import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Facebook.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Instagram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/TikTok.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@filmweb/nextjs/dist/richtext/Twitter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/FilmMainImage.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/app/(web)/film/[edi]/Film.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/DiceRatings.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/DiceValue.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/film/FilmProgram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/film/GalleryContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/Oneliner.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/OverriddenRichText.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/ShortFacts.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/film/TrailerContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/framework/ArticleTitle.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/LinkSvg.module.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/film/FullFacts.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/framework/DynamicAdnuntiusAd.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/images/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/MailchimpSignupForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/MailchimpSignupFormWithUrl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/ShowtimeAnalyticsSignupForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/richtext/YouTube.tsx");
